import { animate, inView, stagger } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

function settle(els, styles, ms) {
  setTimeout(() => {
    els.forEach((el) => Object.assign(el.style, styles));
  }, ms);
}

function hero() {
  const lines = [...document.querySelectorAll(".hero-title .line-inner")];
  const fades = [...document.querySelectorAll("[data-hero-fade]")];
  const frame = document.querySelector(".portrait-frame");
  const img = frame?.querySelector("img");
  const strokes = [...document.querySelectorAll(".hero-rings circle, .hero-rings path")];

  animate(lines, { transform: ["translateY(108%)", "translateY(0%)"] }, { duration: 1.15, delay: stagger(0.13, { startDelay: 0.15 }), ease });
  animate(fades, { opacity: [0, 1], transform: ["translateY(16px)", "translateY(0px)"] }, { duration: 0.9, delay: stagger(0.08, { startDelay: 0.6 }), ease });
  if (frame) {
    animate(frame, { clipPath: ["inset(100% 0% 0% 0% round 999px 999px 28px 28px)", "inset(0% 0% 0% 0% round 999px 999px 28px 28px)"] }, { duration: 1.4, delay: 0.25, ease });
    settle([frame], { clipPath: "none" }, 2200);
  }
  if (img) animate(img, { transform: ["scale(1.22)", "scale(1)"] }, { duration: 1.9, delay: 0.25, ease });
  animate(strokes, { strokeDashoffset: [1, 0] }, { duration: 2.4, delay: stagger(0.14, { startDelay: 0.4 }), ease });

  settle(lines, { transform: "translateY(0%)" }, 2600);
  settle(fades, { opacity: "1", transform: "none" }, 2600);
  settle(strokes, { strokeDashoffset: "0" }, 3800);
}

function reveals() {
  document.querySelectorAll('[data-reveal]:not([data-reveal="clip"])').forEach((el) => {
    const sibs = [...el.parentElement.children].filter((c) => c.hasAttribute("data-reveal"));
    const delay = Math.min(sibs.indexOf(el), 5) * 0.07;
    inView(
      el,
      () => {
        animate(el, { opacity: 1, transform: "translateY(0px)" }, { duration: 0.9, delay, ease });
      },
      { amount: 0.12 }
    );
  });

  document.querySelectorAll('[data-reveal="clip"]').forEach((el) => {
    const wrap = el.closest("[data-reveal-wrap]") || el.parentElement;
    const img = el.querySelector("img");
    inView(
      wrap,
      () => {
        animate(el, { clipPath: "inset(0% 0% 0% 0% round 18px)" }, { duration: 1.3, ease }).then(() => {
          el.style.clipPath = "none";
        });
        if (img) animate(img, { transform: "scale(1)" }, { duration: 1.8, ease });
      },
      { amount: 0.1 }
    );
  });
}

function parallax(lenis) {
  const rings = document.querySelector(".hero-rings");
  const visual = document.querySelector("[data-tilt]");
  const frame = visual?.querySelector(".portrait-frame");
  const update = () => {
    const y = window.scrollY;
    if (y > window.innerHeight * 1.4) return;
    if (rings) rings.style.transform = `translate3d(0, ${y * 0.12}px, 0) rotate(${y * 0.03}deg)`;
    if (visual) visual.style.transform = `translate3d(0, ${y * -0.05}px, 0)`;
  };
  if (lenis) lenis.on("scroll", update);
  else window.addEventListener("scroll", update, { passive: true });

  if (visual && frame && window.matchMedia("(pointer: fine)").matches) {
    visual.addEventListener("pointermove", (e) => {
      const r = visual.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      frame.style.transform = `rotateY(${px * 8}deg) rotateX(${py * -8}deg) translateZ(0)`;
    });
    visual.addEventListener("pointerleave", () => {
      frame.style.transform = "rotateY(0deg) rotateX(0deg)";
    });
  }
}

export function initMotion(lenis) {
  const root = document.documentElement;
  if (!root.classList.contains("js-motion")) return;
  window.__siteReady = true;
  try {
    hero();
    reveals();
    parallax(lenis);
  } catch (err) {
    root.classList.remove("js-motion");
  }
}
